import {
  createHttpResourceLocation,
  Dictionary,
  HttpResourceLocation,
} from '@softline/core';
import { BelegleserConfig, DEFAULT_BELEGLESER_CONFIG } from '../belegleser.shared';

export function belegleserLocation(
  config: BelegleserConfig,
  path: string,
  pathParams?: Dictionary<unknown>,
  queryParams?: Dictionary<unknown>
): HttpResourceLocation {
  return createHttpResourceLocation({
    url: (config.apiBaseUrl ?? DEFAULT_BELEGLESER_CONFIG.apiBaseUrl) + path,
    pathParams,
    queryParams,
  });
}
